import React from 'react';

import { DownloadIcon } from '@vlabs/icons';
import HandlerLink from '@vlabs/shared/components/handler-link/HandlerLink';
import InfoRow from '@vlabs/shared/components/info-row/InfoRow';
import { EventStreamLink } from '@vlabs/shared/components/stream-link/EventStreamLink';
import DownloadButton from '@vlabs/shared/legacy-components/download-button/DownloadButton';
import { parseISOToLocale, downloadJson } from '@vlabs/shared/utils';
import { openConfirmPopup, useWindowSize } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './EventInfoCell.module.sass';

const EventInfoCell = ({
  original,
  className,
  isColumnDirection = true,
}) => {
  const { t } = useTranslation();
  const windowSize = useWindowSize();
  const linkSize = windowSize.width < 1920 ? 'medium' : 'large';
  const onDownloadHandler = ({ event_id, meta }) => {
    const onConfirm = () => {
      downloadJson(`${event_id}_meta`, meta);
    };

    openConfirmPopup({
      icon: <DownloadIcon />,
      title: t('events:confirmation.download_meta.title'),
      message: t('events:confirmation.download_meta.text'),
      onConfirm,
      confirmButtonProps: {
        kind: 'success',
      },
      confirmLabel: t('events:confirmation.submit', { context: 'download' }),
    });
  };

  return (
    <div className={cn(st.RowInfoWidth, className)}>
      {original.create_time && (
        <InfoRow
          columnDirection={isColumnDirection}
          data-testid="eventInfoCell.createTime"
          title={t('date created')}
          value={parseISOToLocale(original.create_time)}
        />
      )}
      {original.source && (
        <InfoRow
          columnDirection={isColumnDirection}
          data-testid="eventInfoCell.source"
          title={t('source')}
          value={original.source}
        />
      )}
      {original.stream_id && (
        <InfoRow
          columnDirection={isColumnDirection}
          data-testid="eventInfoCell.videoStream"
          title={t('video stream')}
          value={<EventStreamLink hideId size={linkSize} streamId={original.stream_id} />}
        />
      )}
      {original.handler_id && (
        <InfoRow
          columnDirection={isColumnDirection}
          data-testid="eventInfoCell.handlers"
          title={t('handler')}
          value={<HandlerLink handlerId={original.handler_id} hideId size={linkSize} />}
        />
      )}
      {original.meta && (
        <div className={cn(st.Meta)}>
          {t('metadata')}
          {DownloadButton({ onClick: () => onDownloadHandler(original) })}
        </div>
      )}
    </div>
  );
};

EventInfoCell.propTypes = {
  original: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  isColumnDirection: PropTypes.bool,
};
EventInfoCell.defaultProps = {
  original: undefined,
  className: undefined,
  isColumnDirection: true,
};

export { EventInfoCell };
